<template>
	<div class="measure-falls">
		<div class="date-time">
			<span class="date">{{ date(value.datetime) }}</span>
			<span class="time">{{ time(value.datetime) }}</span>
		</div>
		<div class="value"><span>fall detected</span></div>
		<div class="svg">
			<d3-generic :value="value.values.fall ? 1 : 0" :icon="'fall'" :domain="domain"/>
		</div>
	</div>
</template>

<script>
import D3Generic from '../../../shared/widgets/measure/D3Generic'
export default {
	components: {
		D3Generic
	},
	props: [
		'value'
	],
	data () {
		return {
			domain: {
				min: 0,
				max: 1
			}
		}
	},
	methods: {
		date (date) {
			return this.$moment(date).format('D MMM')
		},
		time (date) {
			return this.$moment(date).format('HH:mm')
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/readings/biometric/widgets/measure/MeasureFalls.vue